import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {LayoutAlignDirective, LayoutDirective} from '@ngbracket/ngx-layout';
import {CommonsModule, LocalizationService} from '@npck/libs/commons';
import {appApplyTheme, UI_KIT_LIGHT, UiKitModule} from '@npck/libs/ui-kit';

@Component({
    selector: 'qr-service-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [
        LayoutDirective,
        LayoutAlignDirective,
        UiKitModule,
        CommonsModule
    ],
})
export class AppComponent {
    DOCS_URL = 'https://docs.npck.kz/mezhbankovskaya-sistema-perevodov-i-platezhei';

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private localizationService: LocalizationService,
    ) {
        localizationService.defaultInitialization();
        appApplyTheme(UI_KIT_LIGHT);
        this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/temp-cached/sprites/sprite-defs.svg`));
    }

    openDocs(): void {
        window.open(this.DOCS_URL, '_blank');
    }
}
